//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
var ENGAGEMENT_FILTERS = ['journeyId', 'stageId', 'touchpointId', 'touchpointName', 'workflowStepId', 'contactId', 'contactName', 'threadName', 'tag1', 'tag2'];
/**@type {import('../types').DataType<import('./types').EngagementDataModel>} */

var ENGAGEMENT_DATA_TYPE = {
  data: {
    url: '/backend/engagementjobs',
    dataKey: 'engagement',
    idKeyProp: 'Job.ThreadId',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if ((request.type === 'loadView' || request.type === 'loadItem') && options.dataProps) {
        var filter = {};
        Object.keys(options.dataProps).map(function (f) {
          if (ENGAGEMENT_FILTERS.indexOf(f) > -1) filter[f] = options.dataProps[f];
        });
        return {
          query: filter
        };
      }
    }
  },
  placeholders: {
    label: function label(data) {
      return data ? data.Job.ThreadName : '';
    },
    type: function type() {
      return 'engagement';
    },
    icon: function icon() {
      return 'engagement';
    },
    tag1: function tag1(data) {
      return data ? data.Job.Tag1 : '';
    },
    tag2: function tag2(data) {
      return data ? data.Job.Tag2 : '';
    }
  },
  columns: [{
    id: 'ThreadName',
    children: 'Name',
    serverSort: true,
    formatter: function NameFormatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Text, {
        value: data.Job.ThreadName
      });
    },
    width: {
      xl: '25%',
      lg: '20%',
      xs: 'auto'
    }
  }, {
    id: 'Tag1',
    children: 'Id',
    serverSort: true,
    formatter: function IdFormatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Job.Tag1
      });
    },
    width: {
      sm: 170,
      xs: 0
    }
  }, {
    id: 'Tag2',
    children: 'Status',
    serverSort: true,
    formatter: function StatusFormatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Text, {
        value: data.Job.Tag2
      });
    },
    width: {
      md: 150,
      sm: 0,
      xs: 0
    }
  }, {
    id: 'Stage',
    children: 'Stage',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.JourneyStage, {
        value: data.Stage.Name,
        color: data.Stage.Color
      });
    }
  }, {
    id: 'Touchpoint',
    children: 'Touchpoint',
    serverSort: true,
    formatter: function formatter(_ref5) {
      var data = _ref5.data;
      return React.createElement(Formatter.JourneyTouchpoint, {
        value: data.Touchpoint.Name,
        color: data.Touchpoint.Color,
        type: data.Touchpoint.IsMilestone ? 'milestone' : 'touchpoint'
      });
    }
  }, {
    id: 'Contact',
    children: React.createElement(Formatter.Placeholders, {
      template: "{type}",
      dataType: "contact",
      capitalize: true
    }),
    serverSort: true,
    formatter: function formatter(_ref6) {
      var data = _ref6.data;
      return React.createElement(Formatter.Text, {
        value: data.Contact.Name
      });
    }
  }, {
    id: 'Email',
    children: 'Email',
    formatter: function EmailFormatter(_ref7) {
      var data = _ref7.data;
      return React.createElement(Formatter.Text, {
        value: data.Contact.Email
      });
    }
  }, {
    id: 'Phone',
    children: 'Phone',
    formatter: function PhoneFormatter(_ref8) {
      var data = _ref8.data;
      return React.createElement(Formatter.Text, {
        value: data.Contact.Phone
      });
    }
  }, {
    id: 'EnrolledUTC',
    children: 'Created Date',
    serverSort: true,
    formatter: function formatter(_ref9) {
      var data = _ref9.data;
      return React.createElement(Formatter.DateTime, {
        value: data.Job.EnrolledUTC
      });
    },
    width: {
      lg: 210,
      md: 0,
      sm: 0,
      xs: 0
    }
  }, {
    id: 'UpdatedUTC',
    children: 'Last Updated',
    serverSort: true,
    formatter: function formatter(_ref10) {
      var data = _ref10.data;
      return React.createElement(Formatter.DateTime, {
        value: data.Job.UpdatedUTC
      });
    },
    width: {
      md: 210,
      sm: 0,
      xs: 0
    }
  }],
  thumbnail: {
    url: function url() {
      return '';
    },
    text: function text(data) {
      return data.Job.ThreadName;
    },
    icon: function icon() {
      return 'files';
    } // contextMenu: [],

  }
};
export default ENGAGEMENT_DATA_TYPE;